import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminSettings = () => {
  const [contactEmail, setContactEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then(r => setContactEmail(r.data.contact_email || ''))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/settings`, { contact_email: contactEmail });
      toast.success('Settings saved! Contact form will now send to ' + contactEmail);
    } catch {
      toast.error('Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout title="Site Settings">
      {loading ? <div className="text-center py-8 text-gray-500">Loading...</div> : (
        <div className="max-w-xl space-y-6">
          <Card className="border-2">
            <CardHeader>
              <CardTitle>Contact Form Email</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <Label htmlFor="contact_email">Email address that receives contact form submissions</Label>
                <Input
                  id="contact_email"
                  type="email"
                  value={contactEmail}
                  onChange={e => setContactEmail(e.target.value)}
                  placeholder="certs@pushtrainingnc.com"
                  className="mt-1"
                  data-testid="contact-email-input"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Whenever someone submits the Contact Us form, their message will be emailed to this address.
                </p>
              </div>
              <Button
                onClick={save}
                disabled={saving}
                className="bg-red-600 hover:bg-red-700 text-white"
                data-testid="save-settings-btn"
              >
                {saving ? 'Saving...' : 'Save Settings'}
              </Button>
            </CardContent>
          </Card>
        </div>
      )}
    </AdminLayout>
  );
};
